import {DirectDebitfileConfigModel} from "./direct-debitfile-config.model";
import {VatDefaultModel, VatSettingsModel} from "../../vat-setting/models/vat-settings.model";
import {CustomeTripQuestion} from "../../pre-post-trip-question/models/custom-question.model";
import {ValidateLicense24IdCheckOption} from "./validate-license-24idcheck-option";
import {ImportConnectionTypeOption} from "./import-connectiontype-option";

export class InstanceModel {
  public instanceID: number;
  public instanceName: string;
  public isWegoAdmin: boolean;
  public description: string;
  public instanceHashId: string;
  public preferredLanguage: string = "";
  public timeZone: string = "";
  public isBookingApprovalReq: boolean = false;
  public bookingCancelTime: string = "3600";
  public bookingTemporaryTime: string = "300";
  public vtsRequestTimeout: string = "1800";
  public vtsTriplogTimeout: string = "1800";
  public fromEmail: string = "";
  public defaultEmailConfig: boolean = true;
  public host: string = "";
  public port: string = "";
  public userName: string = "";
  public password: string = "";
  public enablessl: boolean = false;
  public countryCode: string = "";
  public helpdeskNo: string;
  public isImportPersonAllow: boolean = false;
  public validateLiceanceNumber: boolean = false;
  public validateLicense24IDCheck: ValidateLicense24IdCheckOption = 2;
  public importConnectionType: ImportConnectionTypeOption = 0;
  public validateLicenseCheckForBooking: boolean = false;
  public dayOfMonth: string;
  public dayOfWeek: string = "";
  public damageImageExtensions: string = "";
  public instanceLogoPath: string;
  public sendInvoiceToDriver: string = "YES";
  public sendInvoiceToOrganization = "YES";
  public isGefenceEnabled: boolean = false;
  //public isCreateOrganizationEnabled: boolean = false;
  public enableSnailTrail: boolean = false;
  public vehicleAtSameLocationTime: string = "";
  public vehicleAtSameLocationTimeInterval: string = "";
  public noBookingInTime: string = "";
  public noBookingInTimeInterval: string = "";
  public appSupportTo: string = "";
  public customerMasterHashId: string = "";
  public customerName: string = "";
  public adminCount: number;
  public geofenceNotificationModel: InstanceNotificationModel;
  public odometerNotificationModel: InstanceNotificationModel;
  public apkMaintenanceNotificationModel: InstanceNotificationModel;
  public reportDamageNotificationModel: InstanceNotificationModel;
  public vehicleSameLocationNotificationModel: InstanceNotificationModel;
  public vehicleNotReturnNotificationModel: InstanceNotificationModel;
  public vehicleNotBookedNotificationModel: InstanceNotificationModel;
  public cleaningRequiredNotificationModel: InstanceNotificationModel;
  public refuelingRequiredNotificationModel: InstanceNotificationModel;
  public lowBatteryNotificationModel: InstanceNotificationModel;
  public lowChargeNotificationModel: InstanceNotificationModel;
  public communicationProblemNotificationModel: InstanceNotificationModel;
  public invalidTagScansNotificationModel: InstanceNotificationModel;

  public geofenceAttributeModel: GeofenceAttributeModel;
  public carwiseConfigurationModel: CarwiseConfigurationModel;
  public locationMode: string = "HOME";
  public bookingCalendarSettingModel: BookingCalendarSettingModel;
  public enableBookingCalendarInfo: boolean = false;
  public odometerConfigurationModel: OdometerConfigurationModel;
  public directDebitfileConfigModel: DirectDebitfileConfigModel;
  public dashboardConfigModel: DashboardConfigModel;
  public brandingTemplateConfig: BrandingTemplateConfig;
  public enableBatchUploadPersonInfo: boolean = false;
  public batchUploadPersonConfigurationModel: BatchUploadPersonConfigurationModel;
  // public vehicleOccupencyReportModulerightsModel: ModuleRightsModel;
  // public revenuePerVehicleReportModulerightsModel: ModuleRightsModel;
  // public tripDataReportReportModulerightsModel: ModuleRightsModel;
  // public maintanancePlanningReportModulerightsModel: ModuleRightsModel;
  public bookingDelayConfig: BookingDelayConfigurationModel;
  public isEditable: boolean;
  public isDeletable: boolean;
  public isAdminCount: boolean;

  public vatSettingDefaultCost: boolean = true;

  public vatSettingsList: Array<VatSettingsModel>;
  public customTripQuestionList: Array<CustomeTripQuestion>;
  public vatDefaultRate: VatDefaultModel;
  // Mobile App Configuration
  public enableNewBooking: boolean = true;
  public enableBookingCalender: boolean = true;
  public enableSubscription: boolean = true;
  public enableUpdateProfile: boolean = true;
  public enableNotification: boolean = true;
  public enableChangeBooking: boolean = true;
  public enableAddExpenseMenu: boolean = true;
  public isPaymentRequired: boolean = false;
  public userBlockMessage: string = "";
  public isChecked: boolean;
  public gdprSettingsModel: GdprSettingsModel;
  public currencyConfigurationModel: CurrencyConfigurationModel;

  // Afas
  public afasClientId: string = "";
  public afasConnectorName: string = "";
  public afasConnectionType: string = "";
  public afasToken: string = "";

  // Azure
  public azureTenantId: string = "";
  public azureClientId: string = "";
  public azureClientSecret: string = "";
  
  //SSO
  public defaultSsoSharedVehicleGroupHashId: string = "";
  public defaultSsoOrganizationHashId: string = "";
  public defaultSsoSubscriptionHashId: string = "";

  //Dropoff Message
  public dropOffExternalUrl: string = "";
  public dropOffApiKey: string = "";
  public dropOffActive: boolean = false;

  //NIF Number
  public enableNIFNumber: boolean = false;
  public invoicePreFix: string;

  public twoFAConfig: TwoFAConfigModel;
  public validateLicenseForAllBookings: boolean = true;

  constructor() {
    this.geofenceAttributeModel = new GeofenceAttributeModel();

    this.geofenceNotificationModel = new InstanceNotificationModel();
    this.apkMaintenanceNotificationModel = new InstanceNotificationModel();
    this.odometerNotificationModel = new InstanceNotificationModel();
    this.reportDamageNotificationModel = new InstanceNotificationModel();
    this.vehicleSameLocationNotificationModel = new InstanceNotificationModel();
    this.vehicleNotReturnNotificationModel = new InstanceNotificationModel();
    this.vehicleNotBookedNotificationModel = new InstanceNotificationModel();
    this.cleaningRequiredNotificationModel = new InstanceNotificationModel();
    this.refuelingRequiredNotificationModel = new InstanceNotificationModel();
    this.lowBatteryNotificationModel = new InstanceNotificationModel();
    this.lowChargeNotificationModel = new InstanceNotificationModel();
    this.communicationProblemNotificationModel = new InstanceNotificationModel();
    this.invalidTagScansNotificationModel = new InstanceNotificationModel();

    this.bookingCalendarSettingModel = new BookingCalendarSettingModel();
    this.odometerConfigurationModel = new OdometerConfigurationModel();
    this.directDebitfileConfigModel = new DirectDebitfileConfigModel();
    this.directDebitfileConfigModel.fileLevel = "COMPANY";
    this.batchUploadPersonConfigurationModel = new BatchUploadPersonConfigurationModel();
    this.dashboardConfigModel = new DashboardConfigModel();
    //this.instanceNotifictionDashbordStatusModel = new InstanceNotifictionDashbordStatusModel();
    this.brandingTemplateConfig = new BrandingTemplateConfig();
    // this.vehicleOccupencyReportModulerightsModel = new ModuleRightsModel();
    // this.revenuePerVehicleReportModulerightsModel = new ModuleRightsModel();
    // this.tripDataReportReportModulerightsModel = new ModuleRightsModel();
    // this.maintanancePlanningReportModulerightsModel = new ModuleRightsModel();
    this.bookingDelayConfig = new BookingDelayConfigurationModel();
    this.bookingDelayConfig.enabled = "NO";
    this.vatSettingsList = new Array<VatSettingsModel>();
    this.vatDefaultRate = new VatDefaultModel();
    this.gdprSettingsModel = new GdprSettingsModel();
    this.carwiseConfigurationModel = new CarwiseConfigurationModel();
    this.currencyConfigurationModel = new CurrencyConfigurationModel();
    this.customTripQuestionList = new Array<CustomeTripQuestion>();
    this.twoFAConfig = new TwoFAConfigModel();
  }
}

export class GeofenceAttributeModel {
  public address: string;
  public latitude: string;
  public longitude: string;
  public radiusInMtr: string;
}

export class CarwiseConfigurationModel {
  public isCarwiseEnabled: boolean = false;
  public carwiseConnectionUrl: string;
  public carwiseConnectionUsername: string;
  public carwiseConnectionPassword: string;
  public carwiseAutoDeleteFrequencyInDays: string;
}

export class InstanceNotificationModel {
  public priority = "NA";
  public isNotificationEnabled: boolean;
  public isEmailEnabled: boolean;
  // public weGoAdmin: boolean;
  // public companyAdmin: boolean;
  // public groupAdmin: boolean;
  // public currentDriver: boolean;
  // public nextDriver: boolean;
}

export class BookingCalendarSettingModel {
  // public CompanyAdmin: boolean;
  // public GroupAdmin: boolean;
  // public OrganizationAdmin: boolean;
  public Driver: boolean;
  public FirstName: boolean;
  public LastName: boolean;
  public Mobile: boolean;
  public Email: boolean;
}

export class OdometerConfigurationModel {
  public enabled: string = "INHERIT";
  public enabledOnApp: boolean = false;
  public warningPercentage: string;
  public frequency: string;
  public timeInterval: string = "";
}

export class BatchUploadPersonConfigurationModel {
  // public companyAdmin: boolean = true;
  // public groupAdmin: boolean = true;
  // public organizationAdmin: boolean = true;
  public sendActivationMail: boolean = true;
  public generateRandom_UseUploadedPassword: boolean = true;
  public fieldPassword: boolean;
  public fieldFirstName: boolean;
  public fieldMiddleName: boolean;
  public fieldLastName: boolean;
  public fieldMobileNumber: boolean;
  public fieldPhoneNumber: boolean;
  public fieldHomeAddress: boolean;
  public fieldWorkAddress: boolean;
  public fieldCountryCode: boolean;
  public fieldRfidTagId: boolean;
  public fieldLicenseTypes: boolean;
  public fieldCertificates: boolean;
  public fieldEmployeeNumber: boolean;
  public fieldAccessCardId: boolean;
  public fieldIBANNumber: boolean;
  public fieldBICCode: boolean;
  public fieldMandateId: boolean;
  public fieldMandateSignatureDate: boolean;
  public fieldIsAmmandment: boolean;
}

export class DashboardConfigModel {
  public enableCurrentLocation: boolean = false;
  public defaultLocation: string = "HOME";
  public defaultStatus: string = "ALL";
  public enableAutoUpdate: boolean = false;
  public updateIntervalInSecond: string;
}

export class BrandingTemplateConfig {
  public ui: string = "INSTANCE";
  public nonBooking: string = "INSTANCE";
  public booking: string = "INSTANCE";
  public invoice: string = "INSTANCE";
}

// export class ModuleRightsModel {
//   public modulerightsHashId: string;
//   public moduleName: string;
//   public companyAdmin: boolean;
//   public groupAdmin: boolean;
// }

export class BookingDelayConfigurationModel {
  public enabled: string;
  public sendToWegoAdmin: boolean;
  public sendToCompanyAdmin: boolean;
  public sendToGroupAdmin: boolean;
}

export class GdprSettingsModel {
  public InactiveAfterDays: string;
  public MarkDeleteAfterDays: string;
  public NotifyAdminBeforeDays: string;
}

export class CurrencyConfigurationModel {
  public currencyName: string;
  public currencyAbbreviation: string = "";
  public currencyNameSingular: string;
  public currencyNamePlural: string;
  public currencySymbol: string;
  public currencySignBeforeAmount: boolean = true;
}

export class TwoFAConfigModel {
  public twoFAConfigHashId: string = "";
  public enabled: string = 'INHERIT';
  public expirationDays: number = 0;
}

export class SharedVehicleGroupDropdownModel {
  public sharedvehiclegroupHashId: string;
  public groupName: string;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/instance/models/instance.model.ts